import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
/**
 * Looks like an arrow up, and accepts `color`, `gradientColors`, and `gradientKey` overrides.
 * Default is `lightPink`.
 *
 * Figma: https://www.figma.com/file/SMqeFyVH6qLbMzeoCHBp4A/Emma-Design-System?node-id=723%3A2620
 */
const IconBoldSaved = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="lightPink">
      <Path fillRule="evenodd" clipRule="evenodd" d="M15.0309 3.30271C13.0299 2.8991 10.9701 2.8991 8.96913 3.30271C6.66186 3.76809 5 5.82231 5 8.20894V18.6292C5 20.4579 6.9567 21.596 8.51221 20.6721L11.3451 18.9895C11.7496 18.7492 12.2504 18.7492 12.6549 18.9895L15.4878 20.6721C17.0433 21.596 19 20.4579 19 18.6292V8.20894C19 5.82231 17.3381 3.76809 15.0309 3.30271Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
export default IconBoldSaved;
